import React from 'react';
import './styles.scss';
import PrintFunctions from '../Print/PrintFunctions';

const DailyAttendanceToPrint = React.forwardRef(({ data }, ref) => {
  const { getEmployeeInfo, getCompanyInfo } = PrintFunctions();

  return (
    <div
      className="table_to_print print_report"
      ref={ref}
      style={{
        margin: '0 auto',
        maxWidth: '800px',
        padding: '20px'
      }}
    >
      {data.length > 0 &&
        data.map(employee => (
          <div key={employee.national_identification} className="employee-report-block">
            <p style={{ fontWeight: 'bold' }}>Reporte de Marcaciones Diarias</p>
            {getCompanyInfo(employee)}
            {getEmployeeInfo(employee)}
            <p>
              <br />
            </p>
            {employee?.attendances_attributes.length > 0 && (
              <table className="table-print table-sm table-bordered">
                <tbody>
                  <tr style={{ backgroundColor: '#EBEBEB' }}>
                    <th className="text-center align-middle">Fecha</th>
                    <th className="text-center align-middle">Hora Marcación</th>
                    <th className="text-center align-middle">Tipo de Registro</th>
                    <th className="text-center align-middle">Medio de Marcación</th>
                    <th className="text-center align-middle">Hash</th>
                  </tr>
                  {employee?.attendances_attributes?.map(attendance => (
                    <tr key={attendance.hash_code || Math.random()}>
                      <th className="text-center align-middle">{attendance.date}</th>
                      <th className="text-center align-middle">{attendance.parsed_time}</th>
                      <th className="text-center align-middle">{attendance.translated_time_type}</th>
                      <th className="text-center align-middle">{attendance.translated_device_type}</th>
                      <th className="text-center align-middle">{attendance.hash_code}</th>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {employee?.attendances_attributes.length === 0 && (
              <p className="text-center">No hay registros para este período.</p>
            )}
          </div>
        ))}
    </div>
  );
});

export default DailyAttendanceToPrint;
